import * as React from 'react';
import { useCarousel } from './carousel';
import { Button } from '../button';
import type { SyntheticEvent } from 'react';
import { cn } from '../../utils/cn';

interface CarouselNextProps extends React.PropsWithChildren {}

export const CarouselNext = (
    props: CarouselNextProps & React.ComponentProps<typeof Button>,
) => {
    const {
        children,
        color = 'secondary',
        size = 'square40',
        // The corner comes from `--radius-btn-m` in the class below, so the
        // shape variant stays the library default and the flag-off render is
        // the disc it has always been.
        shape = 'default',
        inverted = false,
        className,
    } = props;

    const { scrollNext, canScrollPrev, canScrollNext } = useCarousel();
    const enableScroll = canScrollPrev || canScrollNext;

    const onScrollNext = (evt: SyntheticEvent) => {
        evt.preventDefault();
        evt.stopPropagation();
        scrollNext();
    };

    return enableScroll ? (
        <div className="rocco-carousel-next z-20 flex items-center justify-center">
            <Button
                color={color}
                size={size}
                shape={shape}
                inverted={inverted}
                onClick={onScrollNext}
                className={cn(
                    'rounded-[var(--radius-btn-m)]',
                    !canScrollNext && 'pointer-events-auto opacity-50',
                    className,
                )}
            >
                {children}
                <span className="sr-only">Next slide</span>
            </Button>
        </div>
    ) : null;
};
